import { observable, makeObservable } from 'mobx';
import { IFileInstance } from 'stores/BaseInstanceListStore';

export interface IHistorySearch extends IFileInstance {
    id: string;
}

class HistorySearchStore {
    historySearch: IHistorySearch = {
        id: '',
        sha1: '',
        fileRepId: ''
    };

    constructor(historySearch: IHistorySearch) {
        makeObservable(this, {
            historySearch: observable
        });

        this.update(historySearch);
    }

    update(historySearch: IHistorySearch): void {
        this.historySearch = {
            ...this.historySearch,
            ...historySearch
        };
    }
}

export default HistorySearchStore;
